module.exports = __webpack_public_path__ + "img/logo.dd536077.jpg";